export default __webpack_public_path__ + "static/media/heatmap.7163eec4.png";